import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import CircularProgress from "@material-ui/core/CircularProgress";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

import AuthLayout, { useAuthFormStyles } from "../../components/AuthLayout";
import { requestPasswordReset } from "../../services/passwordRecovery.api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

/**
 * Pide el enlace (doc 0446). La respuesta del servidor es la misma exista o no la
 * cuenta, así que la pantalla tampoco distingue: siempre «revisa tu correo».
 */
const ForgotPassword = () => {
  const classes = useAuthFormStyles();
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || sending) return;
    setSending(true);
    try {
      await requestPasswordReset(email.trim());
      setSent(true);
    } catch (err) {
      toastError(err);
    } finally {
      setSending(false);
    }
  };

  const back = (
    <Link component={RouterLink} to="/login" style={{ textAlign: "center", fontSize: 14 }}>
      {i18n.t("passwordRecovery.backToLogin")}
    </Link>
  );

  if (sent) {
    return (
      <AuthLayout title={i18n.t("passwordRecovery.sentTitle")} subtitle={i18n.t("passwordRecovery.sentBody")}>
        <MailOutlineIcon style={{ fontSize: 48, color: "#1E3A8A", alignSelf: "center" }} />
        {back}
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={i18n.t("passwordRecovery.forgotTitle")} subtitle={i18n.t("passwordRecovery.forgotSubtitle")}>
      <form noValidate onSubmit={submit} className={classes.form}>
        <TextField
          variant="outlined"
          className={classes.field}
          fullWidth
          required
          autoFocus
          type="email"
          autoComplete="email"
          label={i18n.t("passwordRecovery.email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          disabled={!email.trim() || sending}
          className={classes.submit}
        >
          {sending ? <CircularProgress size={22} color="inherit" /> : i18n.t("passwordRecovery.send")}
        </Button>
      </form>
      {back}
    </AuthLayout>
  );
};

export default ForgotPassword;
